export const cancelReasons = [
  {
    label: "Missing features",
    value: "missing_features",
  },
  {
    label: "I don't need it anymore",
    value: "i_dont_need_it_anymore",
  },
  {
    label: "Viesus Cloud is too expensive",
    value: "viesus_cloud_is_too_expensive",
  },
  {
    label: "I'm switching to another service",
    value: "i_m_switching_to_another_service",
  },
  {
    label: "Other",
    value: "other",
  },
]
export const downgradeReasons = [
  {
    label: "My image volume is smaller",
    value: "my_image_volume_is_smaller",
  },
  {
    label: "The subscription is too expensive",
    value: "the_subscription_is_too_expensive",
  },
  {
    label: "Other",
    value: "other",
  },
]
